import { render, staticRenderFns } from "./App.vue?vue&type=template&id=936a42c8&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936a42c8",
  null
  
)

export default component.exports